import { configConstants } from '../constants';
import { configService } from '../services';
import { showToast } from '../services/toast';

export const configActions = {
  fetchAppConfigs
};

function fetchAppConfigs() {
  return dispatch => {
    dispatch(request());

    configService.fetchAppConfigs()
      .then(
        response => {
          dispatch(success(response.data));
        },
        error => {
          dispatch(failure(error));
          // showToast(error.toString(), 'error');
        }
      );
  };

  function request() { return { type: configConstants.FETCH_APPCONFIGS_REQUEST } }
  function success(appconfigs) { return { type: configConstants.FETCH_APPCONFIGS_SUCCESS, appconfigs } }
  function failure(error) { return { type: configConstants.FETCH_APPCONFIGS_FAILURE, error } }
}
